import { Component, effect, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { I18nService } from '@gruposaltaedu/liv-i18n/core';

import { AppBootstrapLoadingService } from './core/layout/services/app-bootstrap-loading.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  private readonly bootstrapLoading = inject(AppBootstrapLoadingService);
  private readonly i18n = inject(I18nService);
  private readonly docTitle = inject(Title);

  protected readonly isBootstrapLoading = this.bootstrapLoading.isLoading;

  constructor() {
    effect(() => {
      this.i18n.currentLanguage();
      this.docTitle.setTitle(String(this.i18n.instant('app.documentTitle')));
    });
  }
}
